import "./App.css";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import About from "./components/AboutPage";
import Analysis from "./components/AnalysisPage";
import Topics from "./components/TopicDetailPage";
import { AnalysisProvider } from "./context/AnalysisContext";
import { useDarkMode } from "./hooks/useDarkMode";
import Comparison from "./components/ComparisonPage";
import { ComparisonProvider } from "./context/ComparisonContext";

function App() {
  const [nextTheme, setTheme] = useDarkMode();

  return (
    <div className="App min-h-screen bg-gray-50 dark:bg-slate-950 text-gray-900 dark:text-slate-100 transition-colors duration-300">
      <Header nextTheme={nextTheme} setTheme={setTheme} />
      <main className="max-w-6xl mx-auto px-4 py-8">
        <Routes>
          <Route path="/" element={<About />} />
          <Route
            path="/analysis"
            element={
              <AnalysisProvider>
                <Analysis />
              </AnalysisProvider>
            }
          />
          <Route
            path="/comparison"
            element={
              <ComparisonProvider>
                <Comparison />
              </ComparisonProvider>
            }
          />
          <Route path="/topics" element={<Topics nextTheme={nextTheme} />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
